<div *ngIf="menuId" class="context-dropdown dropdown-menu dropdown-menu-sm {{direction}}" [id]="menuId">
  <a *ngFor="let action of visibleActions" class="dropdown-item" 
    [class.disabled]="!isEnabled(action)"
    [disabled]="!isEnabled(action)"
    (click)="buttonClick(action)">{{ action.name }}</a>
</div>